import { SelectItemProps, SelectListPosition } from '../select/types';
import IconLoader from '../icons/loader';
import IconSelected from '../icons/selected';
import { OptionListProps } from './types';

import styles from './autocomplete.module.css';

export default function OptionList({
  list,
  value = '',
  onSelectChange,
  isLoading,
  ulRef,
  onScroll,
  nextPageIsLoading,
  selectListPosition,
}: OptionListProps) {
  return (
    <ul
      className={`${styles.autocompleteList} ${
        isLoading && !nextPageIsLoading ? styles.listOverflowHidden : ''
      } ${
        selectListPosition === SelectListPosition.BOTTOM
          ? styles.bottomPosition
          : styles.topPosition
      }`}
      ref={ulRef}
      onScroll={onScroll}
    >
      {isLoading && !nextPageIsLoading && (
        <li className={styles.listLoader}>
          <IconLoader />
        </li>
      )}
      {list?.length ? (
        list.map((item: SelectItemProps, index) => (
          <li
            key={`${item.value.toString()}-${item.name.toString()}-${
              item.description
            }`}
            tabIndex={(list?.length || 0) - index}
          >
            <button
              type="button"
              className={`${styles.autocompleteListItemValue} ${
                value?.toString() === item.value.toString()
                  ? styles.autocompleteListItemValueActive
                  : ''
              }`}
              tabIndex={-1}
              onClick={() =>
                onSelectChange({
                  target: { name: item.name, value: item.value },
                })
              }
            >
              <div className={styles.autocompleteListItemTop}>
                <span>{item.highlight || item.name}</span>
                <span className={styles.autocompleteListItemTopRight}>
                  <span
                    className={`${styles.suffixText} ${
                      value?.toString() === item.value.toString()
                        ? styles.suffixActive
                        : ''
                    }`}
                  >
                    {item.suffix || ''}
                  </span>
                  {value?.toString() === item.value.toString() && (
                    <IconSelected />
                  )}
                </span>
              </div>
              {item.description && (
                <div className={styles.description}>{item.description}</div>
              )}
            </button>
          </li>
        ))
      ) : (
        <li className={styles.emptyListItem}>Not Found</li>
      )}
      {nextPageIsLoading && (
        <li className={styles.nextPageLoader}>
          <IconLoader />
        </li>
      )}
    </ul>
  );
}
